import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import React from 'react';
import { theme as defaultTheme } from '../../../assets/themes/theme';
import PromptCard from '../containers/PromptCard';
import TypographyI18N from '../elements/TypographyI18N';

export const SimpleErrorPage = ({ title, message }: { title: string; message: string }): JSX.Element => {
    const theme = createMuiTheme(defaultTheme);
    return (
        <ThemeProvider theme={theme}>
            <PromptCard title={title}>
                <TypographyI18N variant='h2'>{message}</TypographyI18N>
            </PromptCard>
        </ThemeProvider>
    );
};
